import React, { useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { doc, updateDoc } from '@firebase/firestore';
import { db } from '../service/Firebase-config';
import { useGlobalContext } from '../context/GlobalContext';

export default function DialogNewJournal({ open, closeJournal, row }) {
  const { selectedUser } = useGlobalContext();
  const [journal, setJournal] = useState("");
  const [topic, setTopic] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (row) {
      setJournal(row.journal || ""); // Use the existing journal or set an empty string
      setTopic(row.topic || ""); // Use the existing topic or set an empty string
    }
  }, [row]);

  const sendJournal = async () => {
    setIsLoading(true);
    const homeworkRef = doc(db, `students/${selectedUser.uid}/homeworks/`, row.id);
    await updateDoc(homeworkRef, { journal, topic }).then(() => {
      setIsLoading(false);
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await sendJournal();
    if (!isLoading) {
      closeJournal(); 
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={() => {
        if (!isLoading) closeJournal();
      }}
      PaperProps={{ component: 'form', onSubmit: handleSubmit }}
    >
      <DialogTitle>{`${selectedUser?.displayName}'s Performance and Reflection Journal`}</DialogTitle>
      <DialogContent>
        <TextField
          margin="dense"
          id="topic"
          name="topic"
          label="Topic (Teacher Only)"
          multiline
          rows={2}
          fullWidth
          variant="outlined"
          onChange={(e) => setTopic(e.target.value)}
          defaultValue={row?.topic}
        />
        <TextField
          margin="dense"
          id="journal"
          name="journal"
          label="Journal (Teacher Only)"
          multiline
          rows={4}
          fullWidth
          variant="outlined"
          onChange={(e) => setJournal(e.target.value)}
          defaultValue={row?.journal}
        />
        <TextField
          margin="dense"
          id="adminComment"
          name="adminComment"
          label="Admin Comment (Admin Only)"
          multiline
          rows={4}
          fullWidth
          variant="outlined"
          disabled
          value={row?.adminComment || " "}
        />
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            if (!isLoading) closeJournal();
          }}
        >
          Cancel
        </Button>
        <LoadingButton loading={isLoading} type="submit">
          Save
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}